module.exports = __webpack_public_path__ + "static/c1-214577ab55a73be3e1a6b3b6dee11d65.jpg";